
import {mapGetters} from 'vuex';

export default {
  name: 'schedule-filter-mobile',
  model: {
    prop: 'request',
    event: 'change',
  },
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isFilter: false,
    };
  },
  computed: {
    ...mapGetters([
      'getPricesStatistic',
      'hasPrices',
    ]),
  },
  methods: {
    openFilter() {
      this.isFilter = true;
    },
    closeFilter() {
      this.isFilter = false;
    },
    getPrices() {
      const res = this.getPricesStatistic(this.request.from.code, this.request.to.code);
      return res;
    },
  },
};
